module.exports = __webpack_public_path__ + "static/media/17_l_truba2_0_34.26.f234f6fc.png";